import {Catalog} from '../../../../common/types/common';
import { BankTarget } from '../types';

export class CalculatorTurboCashStepViewFieldErrorState {
    yearFieldError: string;
    brandFieldError: string;
    modelFieldError: string;
    versionFieldError: string;
    provinceFieldError: string;
    assemblyCountryFieldError: string;
    priceFieldError: string;
    downPaymentFieldError: string;
    monthlyPaymentFieldError: string;

    constructor(yearFieldError: string = null,
                brandFieldError: string = null,
                modelFieldError: string = null,
                versionFieldError: string = null,
                provinceFieldError: string = null,
                assemblyCountryFieldError: string = null,
                priceFieldError: string = null,
                downPaymentFieldError: string = null,
                monthlyPaymentFieldError: string = null) {
        this.yearFieldError = yearFieldError;
        this.brandFieldError = brandFieldError;
        this.modelFieldError = modelFieldError;
        this.versionFieldError = versionFieldError;
        this.provinceFieldError = provinceFieldError;
        this.assemblyCountryFieldError = assemblyCountryFieldError;
        this.priceFieldError = priceFieldError;
        this.downPaymentFieldError = downPaymentFieldError;
        this.monthlyPaymentFieldError = monthlyPaymentFieldError;
    }
}

export class PersonalDataTurboCashStepViewFieldErrorState {
    firstNameFieldError: string;
    secondNameFieldError: string;
    lastNameFieldError: string;
    secondLastNameFieldError: string;
    birthDateFieldError: string;
    docNumberFieldError: string;
    cellPhoneFieldError: string;
    civilStatusFieldError: string;
    regimeFieldError: string;
    rolHomeFieldError: string;
    studiesFieldError: string;
    houseTypeFieldError: string;
    amountDependentsFieldError: string;
    cURPFieldError: string;
    rootFieldError: string;
    lapseFieldError: string;

    constructor(firstNameFieldError: string = null,
                secondNameFieldError: string = null,
                lastNameFieldError: string = null,
                secondLastNameFieldError: string = null,
                birthDateFieldError: string = null,
                docNumberFieldError: string = null,
                cellPhoneFieldError: string = null,
                civilStatusFieldError: string = null,
                regimeFieldError: string = null,
                rolHomeFieldError: string = null,
                studiesFieldError: string = null,
                houseTypeFieldError: string = null,
                amountDependentsFieldError: string = null,
                cURPFieldError: string = null,
                rootFieldError: string = null,
                lapseFieldError: string = null) {
        this.firstNameFieldError = firstNameFieldError;
        this.secondNameFieldError = secondNameFieldError;
        this.lastNameFieldError = lastNameFieldError;
        this.secondLastNameFieldError = secondLastNameFieldError;
        this.birthDateFieldError = birthDateFieldError;
        this.docNumberFieldError = docNumberFieldError;
        this.cellPhoneFieldError = cellPhoneFieldError;
        this.civilStatusFieldError = civilStatusFieldError;
        this.regimeFieldError = regimeFieldError;
        this.rolHomeFieldError = rolHomeFieldError;
        this.studiesFieldError = studiesFieldError;
        this.houseTypeFieldError = houseTypeFieldError;
        this.amountDependentsFieldError = amountDependentsFieldError;
        this.cURPFieldError = cURPFieldError;
        this.rootFieldError = rootFieldError;
        this.lapseFieldError = lapseFieldError;
    }
}

export interface CalculatorTurboCashStepViewState {
    fieldErrors: CalculatorTurboCashStepViewFieldErrorState;
}

export interface PersonalDataTurboCashStepViewState {
    fieldErrors: PersonalDataTurboCashStepViewFieldErrorState;
}

export class WorkDataTurboCashStepViewErrorFieldState {
    workplaceNameFieldError: string;
    positionFieldError: string;
    workingSinceFieldError: string;
    addressFieldError: string;
    extNumberFieldError: string;
    intNumberFieldError: string;
    streetBetweenFieldError: string;
    workplacePhoneFieldError: string;
    workplacePhoneExtError: string;
    monthlyIncomesFieldError: string;
    postalCodeFieldError: string;
    stateFieldError: string;
    cityFieldError: string;
    municipalityFieldError: string;
    selectedColonyFieldError: string;
    employmentRotationFieldError: string;

    constructor(workplaceNameFieldError: string = null,
                positionFieldError: string = null,
                workingSinceFieldError: string = null,
                addressFieldError: string = null,
                extNumberFieldError: string = null,
                intNumberFieldError: string = null,
                streetBetweenFieldError: string = null,
                workplacePhoneFieldError: string = null,
                workplacePhoneExtError: string = null,
                monthlyIncomesFieldError: string = null,
                postalCodeFieldError: string = null,
                stateFieldError: string = null,
                cityFieldError: string = null,
                municipalityFieldError: string = null,
                selectedColonyFieldError: string = null,
                employmentRotationFieldError: string = null) {
        this.workplaceNameFieldError = workplaceNameFieldError;
        this.positionFieldError = positionFieldError;
        this.workingSinceFieldError = workingSinceFieldError;
        this.addressFieldError = addressFieldError;
        this.postalCodeFieldError = postalCodeFieldError;
        this.stateFieldError = stateFieldError;
        this.cityFieldError = cityFieldError;
        this.municipalityFieldError = municipalityFieldError;
        this.selectedColonyFieldError = selectedColonyFieldError;
        this.workplacePhoneFieldError = workplacePhoneFieldError;
        this.workplacePhoneExtError = workplacePhoneExtError;
        this.monthlyIncomesFieldError = monthlyIncomesFieldError;
        this.extNumberFieldError = extNumberFieldError;
        this.streetBetweenFieldError = streetBetweenFieldError;
        this.employmentRotationFieldError = employmentRotationFieldError;
    }

}

export interface WorkDataTurboCashStepViewState {
    hasPostalCodeError: boolean;
    fieldErrors: WorkDataTurboCashStepViewErrorFieldState;
}

export class HomeDataTurboCashStepViewFieldErrorState {
    addressFieldError: string;
    extNumberFieldError: string;
    intNumberFieldError: string;
    postalCodeFieldError: string;
    stateFieldError: string;
    cityFieldError: string;
    municipalityFieldError: string;
    selectedColonyFieldError: string;
    phoneFieldError: string;

    constructor(addressFieldError: string = null,
                extNumberFieldError: string = null,
                intNumberFieldError: string = null,
                postalCodeFieldError: string = null,
                stateFieldError: string = null,
                cityFieldError: string = null,
                municipalityFieldError: string = null,
                selectedColonyFieldError: string = null,
                phoneFieldError: string = null) {
        this.addressFieldError = addressFieldError;
        this.extNumberFieldError = extNumberFieldError;
        this.intNumberFieldError = intNumberFieldError;
        this.postalCodeFieldError = postalCodeFieldError;
        this.stateFieldError = stateFieldError;
        this.cityFieldError = cityFieldError;
        this.municipalityFieldError = municipalityFieldError;
        this.selectedColonyFieldError = selectedColonyFieldError;
        this.phoneFieldError = phoneFieldError;
    }
}

export interface HomeDataTurboCashStepViewState {
    hasPostalCodeError: boolean;
    fieldErrors: HomeDataTurboCashStepViewFieldErrorState;
}

export interface MonthlyPaymentState {

}

export interface CalculatorState {
    price: string;
    downPayment: string;
    months: number;
    quotas: any;
    monthlyPayment: MonthlyPaymentState;
    hasInsurance: boolean;
    failInsurance: boolean;
    bank: BankTarget;
    queryStringPrice: number;
    queryStringDownPayment: number;
    vpiQS: string;
    isUrlFromPI: boolean;
    brandSelected: Catalog;
    modelSelected: Catalog;
    versionSelected: Catalog;
    yearSelected: Catalog;
    provinceSelected: Catalog;
    assemblyCountrySelected: Catalog;
    postalCode: string;
}

export interface ApplicantHomeState {
    address: string;
    extNumber: string;
    intNumber: string;
    postalCode: string;
    state: Catalog;
    city: Catalog;
    municipality: Catalog;
    colonies: Catalog[];
    selectedColony: Catalog;
    phone: string;
}

export interface ApplicantPersonalState {
    firstName: string;
    secondName: string;
    lastName: string;
    secondLastName: string;
    birthDate: string;
    docNumber: string;
    cellPhone: string;
    email: string;
    civilStatus: Catalog;
    regime: Catalog;
    rolHome: Catalog;
    studies: Catalog;
    houseType: Catalog;
    amountDependents: string;
    cURP: string;
    houseHoldTime: Catalog;
    houseHoldMeasure: Catalog;
}

export interface ApplicantEmploymentState {
    workplaceName: string;
    position: string;
    workingSince: string;
    employmentRotation: Catalog;
    address: string;
    extNumber: string;
    intNumber: string;
    streetBetween: string;
    monthlyIncomes: string;
    postalCode: string;
    state: Catalog;
    city: Catalog;
    municipality: Catalog;
    colonies: Catalog[];
    selectedColony: Catalog;
    workplacePhone: string;
    workplacePhoneExt: string;
}

export interface OtherReferencesState {
    tempDataReference : TempDataReferenceState;
    references: ReferenceState[]
}

export interface TempDataReferenceState {
    index: number;
    data: TempDataReference;
}

export interface TempDataReference {
    state: Catalog;
    city: Catalog;
    municipality: Catalog;
    colonies: Catalog[];
    selectedColony: Catalog;
}

export interface ReferenceState {
    completeName: string;
    cellphone: string;
    phone: string;
    address: string;
    extNumber: string;
    intNumber: string;
    postalCode: string;
    state: Catalog;
    city: Catalog;
    municipality: Catalog;
    colonies: Catalog[];
    selectedColony: Catalog;
}

export interface SummaryState {
    desiredVehicle: string;
    price: string;
    downPayment: string;
    term: string;
    amountFinance: string;
    detailCommission: string;
    monthlyPayment: string;
    monthlyInsurance: string;
}

export interface FileState {
}

export interface HomeFileState {
    homeFiles: FileState[];
}

export interface OtherFileState {
    otherMonth1Files: FileState[];
    otherMonth2Files: FileState[];
    otherMonth3Files: FileState[];
}

export interface IdentificationFileState {
    ifeFrontFiles: FileState[];
    ifeBackFiles: FileState[];
}

export interface CarLicenceFileState {
    carLicenceFrontFiles: FileState[];
    carLicenceBackFiles: FileState[];
}

export interface FilesState {
    identification: IdentificationFileState;
    home: HomeFileState;
    other: OtherFileState;
    carLicence: CarLicenceFileState;
}

export interface TurboCashUIState {
    personalDataStepView: PersonalDataTurboCashStepViewState;
    calculatorStepView: CalculatorTurboCashStepViewState;
    homeDataStepView: HomeDataTurboCashStepViewState;
    workDataStepView: WorkDataTurboCashStepViewState;
}

export interface TurboCashLoanApplicationState {
    currentStep: number;
    highestStep: number;
    applicantPersonal: ApplicantPersonalState;
    applicantHome: ApplicantHomeState;
    applicantEmployment: ApplicantEmploymentState;
    otherReferences: OtherReferencesState;
    token: string;
    createdAt: string;
    summary: SummaryState;
    files: FilesState;
}
